import { render, staticRenderFns } from "./UserLicenses.vue?vue&type=template&id=019b2ad7&scoped=true"
import script from "./UserLicenses.vue?vue&type=script&lang=js"
export * from "./UserLicenses.vue?vue&type=script&lang=js"
import style0 from "./UserLicenses.vue?vue&type=style&index=0&id=019b2ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b2ad7",
  null
  
)

export default component.exports